import instanceQuery from '../../../graphql/queries/bank/BankTransferTransactionQuery.graphql';
import fragment from '../../../graphql/fragments/nominal/PostedTransactionsFragment.graphql';

const BankTransferTransactions = {
  type: 'PostedTransactionsResponse',
  formTitle: 'Posted Transactions',
  instance: instanceQuery,
  fragment,
};

export default BankTransferTransactions;
